import { Directive, input } from '@angular/core';

export interface SelectTemplateContext<T> {
  $implicit: T;
}
@Directive({
  selector: 'ng-template[unityTyped]',
  standalone: true,
})
export class TypedDirective<T> {
  public readonly $unityTyped = input.required<T[]>({ alias: 'unityTyped' });

  // Narrow the type of the context using the generic type of the directive.
  public static ngTemplateContextGuard<T>(dir: TypedDirective<T>, ctx: unknown): ctx is SelectTemplateContext<T> {
    return true;
  }
}
